import { useFontLoader } from '~/hooks/useFontLoader';
import { usePublicHeadlineFont } from '~/hooks/usePublicHeadlineFont';

/**
 * Marks the loader's injected `<head>` tag so tests (and debugging humans) can find it. Kept
 * distinct from the generic loader's default attribute so a share page's headline tag is
 * distinguishable from any other font the page loads.
 */
export const PUBLIC_HEADLINE_FONT_LOADER_ATTRIBUTE = 'data-public-headline-font-loader';

/**
 * Loads the share link's custom headline font into the document, when the publisher set one — a
 * thin public binding of {@link useFontLoader}. Must be called within a `ShortIdProvider`; no-op
 * when the link has no headline font.
 */
export const usePublicHeadlineFontLoader = (): void => {
  const headlineFont = usePublicHeadlineFont();

  useFontLoader(headlineFont, { markerAttribute: PUBLIC_HEADLINE_FONT_LOADER_ATTRIBUTE });
};
